var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100vh","min-height":"100vh","display":"flex","flex-direction":"column","justify-content":"space-between"}},[_c('div',{staticStyle:{"width":"100%"}},[_c('headView',{ref:"headview"}),_c('router-view',{ref:"pageVIEW"})],1),_c('div',{staticStyle:{"width":"100%"}},[_c('buttom')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }